<div
  *ngIf="vm$ | async as vm"
  class="contentful-overlay"
  [ngClass]="vm.isMobileView ? 'contentful-overlay--mobile' : 'contentful-overlay--desktop'"
>
  <div class="contentful-overlay__container">
    <tpm-button
      tpmOverlayControl
      button-link
      data-cy="back-to-home-button"
      icon="gpi-chevron-left"
      *ngIf="!vm.isMobileView"
    >
      {{ "CONTENTFUL.BACK_TO_START_PAGE" | translate }}
    </tpm-button>
    <div class="header-row">
      <p class="contentful-overlay__headline headline-title">{{ headline }}</p>
      <tpm-icon
        *ngIf="vm.isMobileView"
        class="close-button"
        icon="gpi-filled-cross"
        data-cy="mobile-back-to-home-button"
        (click)="onClose()"
        tpmOverlayControl
      ></tpm-icon>
    </div>
    <tpm-contentful-wrapper-navigation
      [isMobileView]="vm.isMobileView"
      [contentType]="contentType"
      [contentTypeToggles]="contentTypeToggles"
      [moduleSelectOptions]="vm.moduleSelectOptions"
      [useChipSet]="useChipSet"
      (searchChange)="searchChange.emit($event)"
      (moduleChange)="moduleChange.emit($event)"
      (contentTypeChange)="contentTypeChange.emit($event)"
    ></tpm-contentful-wrapper-navigation>
    <div class="contentful-overlay__content-wrapper">
      <ng-content></ng-content>
    </div>
  </div>
</div>
